module.exports = __webpack_public_path__ + "img/20190709163536927.71fb984f.png";